import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import {
  StyledCheckbox,
  StyledInnerTextContainer,
  StyledSpanTextContainer
} from 'pages/VendorsTablePage/components/VendorsTable/styled';
import { VendorsTableDataType } from 'pages/VendorsTablePage/components/VendorsTable/types';
import { StyledCheckboxRenderer } from './styled';
import { useHighVolumeCheckboxRenderer } from './useHighVolumeCheckboxRenderer';

export const HighVolumeCheckboxRenderer: FC<
  ICellRendererParams<VendorsTableDataType>
> = ({ node }) => {
  const { isDisabled, isChecked, isIndeterminate, rowLabel, handleChange } =
    useHighVolumeCheckboxRenderer(node);

  return (
    <StyledCheckboxRenderer>
      <StyledCheckbox
        checked={isChecked}
        data-testid={`vendors-table-checkbox-${node.id}`}
        indeterminate={isIndeterminate}
        isDisabled={isDisabled}
        name={`checkbox-${node.id || 'unknown'}`}
        onChange={handleChange}
      />
      <StyledInnerTextContainer>
        <StyledSpanTextContainer>{rowLabel}</StyledSpanTextContainer>
      </StyledInnerTextContainer>
    </StyledCheckboxRenderer>
  );
};

export default HighVolumeCheckboxRenderer;
